import { cloudFunction } from 'services/parse';

export const createUserInventoryMapping = (data: Record<string, any>)=>{
  return cloudFunction('createUserInventoryMapping',data);
};

export const updateUserInventoryMapping = (data: Record<string, any>)=>{
  return cloudFunction('updateUserInventoryMapping',data);
};

export const deleteUserInventoryMapping = (id: string)=>{
  return cloudFunction('deleteUserInventoryMapping',{ id });
};

export const fetchUserInventoryMapping = (userId: string,inventoryItemId: string)=>{
  return cloudFunction('fetchUserInventoryMapping',{ userId,inventoryItemId });
};

export const fetchAllUserInventoryMapping = (data: Record<string, any>)=>{
  return cloudFunction('fetchAllUserInventoryMapping', data);
};